/* eslint-disable unused-imports/no-unused-vars */
import { usePagesStore, useSettingStore } from 'pinia-store'

export default defineNuxtRouteMiddleware(async (to, from) => {
  try {
    const useSetting = useSettingStore()
    const language = useSetting.lang
    function uniqFast(a, slug: string = 'slug') {
      const seen = {}
      const out: any = []
      const len = a.length
      let j = 0
      for (let i = 0; i < len; i++) {
        const item = a[i][slug]
        if (seen[item] !== 1) {
          seen[item] = 1
          out[j++] = a[i]
        }
      }
      return out
    }
    function findSlug(data, name: string, slug: string = 'slug') {
      let bool = false
      for (let i = 0; i < data.length; i++) {
        const obj = data[i]
        if (obj?.[slug] === name) {
          bool = true
          break
        }
      }
      return bool
    }
    const {
      list,
    } = usePagesStore()
    let pages = []
    if (list && list.length) {
      const arr = list.map(({ slug }: any) => ({ slug }))
      pages = uniqFast(arr)
    }
    // check pages if not available will redirect to home
    if (pages && pages.length && !findSlug(pages, to.name, 'slug')
      && ['rooms-', 'whats-new-', 'additional'].findIndex(el => to.name.includes(el)) === -1) {
      setTimeout(() => {
        // return navigateTo({
        //   name: 'home',
        //   params: {
        //     language,
        //   },
        // })
      }, 1000)
    }
  }
  catch (e) {
    console.warn('[middleware] ', e)
  }

  // const nuxtApp = useNuxtApp()
  // const runtimeConfig = useRuntimeConfig()
})
